<template>
  <div :class="classModifiers">
    <div class="market-biggest-gains__swiper-arrows" v-if="shouldShowMobileSlider">
      <span @click="prevSlide" :class="prevArrowModifiers"></span>
      <span @click="nextSlide" :class="nextArrowModifiers"></span>
    </div>
    <div class="content-loader" v-if="!isComponentReady">
      <div class="content-loader-item" v-for="index in dummyComponents" :key="index">
        <biggest-gains-loader></biggest-gains-loader>
      </div>
    </div>
    <template v-else>
      <div v-if="shouldShowMobileSlider">
        <swiper
          class="market-biggest-gains__slider"
          v-bind="swiperOptions"
          :modules="swiperModules"
          ref="market-biggest-gains-slider"
          @swiper="onSwiperReady"
          @transitionStart="onTransitionStart"
        >
          <swiper-slide
            v-for="(group, idx) in items"
            :key="idx"
            class="market-biggest-gains__slide"
          >
            <market-biggest-gains-element :promo="group[0]"></market-biggest-gains-element>
            <market-biggest-gains-element
              v-if="group[1]"
              :promo="group[1]"
              :header="false"
            ></market-biggest-gains-element>
          </swiper-slide>
        </swiper>
      </div>
      <div v-if="shouldShowDesktopList">
        <div v-if="gainsData.length" class="market-biggest-gains__slide">
          <div class="market-biggest-gains__header">
            <div class="market-biggest-gains__header-title">Biggest 24 hour Gains</div>
            <slot name="pin"></slot>
          </div>
          <market-biggest-gains-element
            :promo="gainsData[0]"
            :header="false"
          ></market-biggest-gains-element>
        </div>
        <div v-if="lossesData.length" class="market-biggest-gains__slide">
          <div class="market-biggest-gains__header">
            <div class="market-biggest-gains__header-title">Biggest 24 hour Losses</div>
            <slot name="pin"></slot>
          </div>
          <market-biggest-gains-element
            :promo="lossesData[0]"
            :header="false"
          ></market-biggest-gains-element>
        </div>
      </div>
    </template>
  </div>
</template>

<script src="./market-biggest-gains.js"></script>
<style src="./market-biggest-gains.scss" lang="scss"></style>
